import type { CSSProperties, ReactNode } from "react";

export const cardGlass: CSSProperties = {
  backgroundColor: "rgba(255,255,255,0.55)",
  backdropFilter: "blur(20px) saturate(1.3)",
  WebkitBackdropFilter: "blur(20px) saturate(1.3)",
  border: "1px solid rgba(0,0,0,0.08)",
  boxShadow: "0 4px 24px -8px rgba(0,0,0,0.08)",
};

export function Card({
  children,
  className = "",
  style,
}: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div className={`rounded-2xl ${className}`} style={{ ...cardGlass, ...style }}>
      {children}
    </div>
  );
}

export function Badge({ label, color }: { label: string; color: string }) {
  return (
    <span
      className="text-xs font-semibold px-2 py-0.5 rounded-full"
      style={{ backgroundColor: `${color}1A`, color }}
    >
      {label}
    </span>
  );
}
